import { fetchManageRenewalsTotals } from './fetchManageRenewalsTotals';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { browserClient } from '../../../react-query';
import { GlobalReactQueryOptions } from '../../../config';
import { useDispatch } from 'react-redux';
import { ErrorResponse, globalError } from '../../../store/notifications/actions';
import { SummaryTotalsOut } from '../../../store/api';

const CACHE_KEY = 'manageRenewalsTotals';

export const useManageRenewalsTotals = (options: UseQueryOptions<SummaryTotalsOut, ErrorResponse> = {}) => {
    const dispatch = useDispatch();

    return useQuery<SummaryTotalsOut, ErrorResponse>([CACHE_KEY], fetchManageRenewalsTotals, {
        ...GlobalReactQueryOptions,
        ...options,
        onError: error => {
            dispatch(globalError(error));
        }
    });
};

export const invalidateManageRenewalsTotals = () => {
    return browserClient.invalidateQueries([CACHE_KEY]);
};
